import React, { useState,useEffect } from "react";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {Link} from 'react-scroll'
import "./css/BackToTop.css"

export default function BackToTop(){

    const [isActive, setActive] = useState(false)
    
    const listenScrollEvent = () => {
        let hero = document.getElementById('hero').clientHeight;
        if (window.scrollY > hero){
            setActive(true);
        } else {
            setActive(false);
        }    
    }
    
    useEffect(() => {
        window.addEventListener('scroll', listenScrollEvent)
    },[])

    return (
        <Link to='hero' smooth={true} className={ isActive ? "back-to-top d-flex align-items-center justify-content-center active" : "d-flex align-items-center justify-content-center back-to-top"}>
            <FontAwesomeIcon className="icon-to-top" icon={faArrowUp}></FontAwesomeIcon>
        </Link>
    )
    // }
}